export const setLocalStorageItem = (key: string, value: string): void => {
  window.localStorage.setItem(key, value);
};

export const getLocalStorageItem = (key: string): any => {
  return window.localStorage.getItem(key);
};

export  const removeLocalStorageItem = (key: string): void => {
  window.localStorage.removeItem(key);
}
